import { createCookie, readCookie } from '../utilities/cookies';

const $document = $(document);

/**
 * Check for cookie and open cookie popup
 */
$document.ready(function() {
  const $cookiePopup = $('.cookies');

  if (! readCookie('cookiePopup') && $cookiePopup.length > 0) {
    $cookiePopup.addClass('is-visible');
  }

  if (Shopify.designMode) {
    $cookiePopup.addClass('is-visible');
  }
});

/**
 * Close Popup and set cookie for 30 days
 */
$document.on('click', '.js-close-cookies-popup', function(event) {
  const $this = $(this);
  const $parent = $this.closest('.cookies');
  const $subscribePopup = $('.js-subscribe-popup');

  $parent
    .removeClass('is-visible')
    .removeClass('cookies--admin-panel');

  if (! Shopify.designMode) {
    createCookie('cookiePopup', 'true', 30);
  }

  if ($subscribePopup.length > 0) {
    $subscribePopup.attr('style', '');

    if ($(window).innerWidth() <= 767) {
      $subscribePopup.css('bottom', '-10px');
    }
  }

  event.preventDefault();
});
